import type { KostDataImportProcessData } from './import-process';

/** Navigation and immutable step updates shared by the DE, AT and CH import flows. */
export class KostDataImportWizardState<Data extends KostDataImportProcessData> {
  public currentStep = {
    index: 1,
    allowPrevious: false,
    allowNext: false,
  };

  private readonly completedSteps: Record<number, boolean> = {
    1: false,
    2: false,
    3: false,
    4: false,
  };

  constructor(public processData: Data) {}

  public activateStep(stepNumber: number): void {
    this.currentStep.index = stepNumber;
    this.updateStepDirectionAllowed();
  }

  public onStepUpdate(event: {
    data: KostDataImportProcessData | Data;
    complete: boolean;
  }): void {
    this.processData = { ...(event.data as Data) };
    this.completedSteps[this.currentStep.index] = event.complete;
    this.updateStepDirectionAllowed();
  }

  private updateStepDirectionAllowed(): void {
    this.currentStep = {
      ...this.currentStep,
      allowNext: this.completedSteps[this.currentStep.index],
      allowPrevious: this.currentStep.index > 0,
    };
  }
}
